import React, {Component} from 'react';
import { connectStream } from '../../lib/bastetjs/utils/connectStream';
import { Nobles } from '../../lib/anuket';
import { IndividualResultsStreams } from '../../data/IndividualResultsStreams';
import HeartOutline from 'react-icons/lib/fa/heart-o';
import HeartFilled from 'react-icons/lib/fa/heart';
import { colors } from '../../shared/styles';
import {nobleParams} from '../../shared/util';
import { heartThisPage } from './styles';
import _ from 'lodash';

export class HeartThisPageComponent extends Component {

  static defaultProps = {
    cheersData: { Result: { cheers: [] } },
  };

  toggleHearted() {
    const { cheersData } = this.props;
    const { Result: { cheers: { ViewerHasCheer } } } = cheersData;
    if (ViewerHasCheer) {
      Nobles.AthletesNoble.unheartResult(nobleParams(this.props)).subscribe(() =>
        IndividualResultsStreams.pullLikesComments(nobleParams(this.props))
      );
    } else {
      Nobles.AthletesNoble.heartResult(nobleParams(this.props)).subscribe(() =>
        IndividualResultsStreams.pullLikesComments(nobleParams(this.props))
      );
    }
  }

  onTouchTap = () => {
    this.props.modal.props.isLoggedIn ? this.toggleHearted() : this.props.modal.handleTouchTap();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const curNobleParams = nobleParams(this.props);
    const nextNobleParams = nobleParams(nextProps);
    if (!_.isEqual(curNobleParams, nextNobleParams)) {
      IndividualResultsStreams.pullLikesComments(nextNobleParams)
    }
  }

  render() {

    const { cheersData } = this.props;

    if(cheersData.isLoading) { return (<div>Loading.....</div>)}

    const { Result: { cheers: { CheerCount = 0, ViewerHasCheer } = {} } = {cheers: {}} } = cheersData;

    const HeartIcon =  ViewerHasCheer ? HeartFilled : HeartOutline;

    const numCheersStr = `( ${CheerCount} )`;

    return (
      <div style={{display: 'inline-flex'}}>
        <div id='heart-icon' data-viewerHasCheer={ViewerHasCheer}>
          <HeartIcon
            onClick={this.onTouchTap}
            style={{cursor:'pointer'}}
            size={20}
            color={colors.blue}>
          </HeartIcon>
        </div>
        <span
          style={heartThisPage.cheerNumberText(CheerCount)}
          id='number-of-cheers'>
          {numCheersStr}
        </span>
      </div>
    );
  }
}

export const HeartThisPage = connectStream({
  cheersData: IndividualResultsStreams.getLikesCommentsStream,
})(HeartThisPageComponent);



/** WEBPACK FOOTER **
 ** ./components/control/HeartThisPage.js
 **/